import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "../../models/subscription";
import {AthleteService} from "../../services/athlete/athlete.service";
import {athleteSeasonStatus, AthleteStatusInfo} from "../../resources/athlete-status";

@Component({
    selector: 'app-user-subscriptions',
    templateUrl: './user-subscriptions.component.html'
})
export class UserSubscriptionsComponent extends BaseComponent implements OnInit {

    athleteId: string | undefined;
    subscriptions: Subscription[] = [];
    loading = true;

    constructor(public route: ActivatedRoute, public athleteService: AthleteService, public serviceInjector: Injector) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.athleteId = this.route.snapshot.params['athleteId'];
        try {
            const rows = this.athleteId ? await this.athleteService.getAthleteSeasons(this.athleteId) : [];
            this.subscriptions = rows.map((item: any) => new Subscription(item));
        } finally {
            this.loading = false;
        }
    }

    status(subscription: Subscription): AthleteStatusInfo {
        return athleteSeasonStatus(subscription.status);
    }

    receiptUrl(subscription: Subscription): string | null {
        const request = subscription.athletePaymentRequest;
        return request?.status === 'paid' && request.receiptUrl ? request.receiptUrl : null;
    }
}
